<template>
  <luma-empty>
        <b-tabs>
          <b-tab title="E-Mail"
                 id='email-tab'>
            <luma-user-email  @saveEmail="saveEmail"
                              :email="account.email"
                              :username="account.username">
            </luma-user-email>
          </b-tab>
          <b-tab title="Passwort">
            <luma-user-password @savePassword="savePassword">
            </luma-user-password>
          </b-tab>

          <b-tab  title="Rechte" @click="updateRights()">
            <b-card v-if="!updateTab">
              <luma-account-rights  :user_name="account.username"
                                    @emitRights="changes">
              </luma-account-rights>
            </b-card>
          </b-tab>
        </b-tabs>
    <luma-save-changes-button v-if="permissionChange"
                              @save="savePermissions">
    </luma-save-changes-button>
<!--    <b-modal id="openChanges">-->
<!--      <b-container class="text-center">-->
<!--        <h1>Offene Änderungen</h1>-->
<!--        <h3>Benutzer Rechte Speichern?</h3>-->
<!--      </b-container>-->
<!--      <template v-slot:modal-footer>-->
<!--        <b-button variant="primary"-->
<!--                  @click="savePermissions(), $bvModal.hide('openChanges')">-->
<!--          Speichern-->
<!--        </b-button>-->
<!--        <b-button @click="abortChanges()">-->
<!--          Abbrechen-->
<!--        </b-button>-->
<!--      </template>-->
<!--    </b-modal>-->

  </luma-empty>
</template>

<script>
  import LumaEmpty from "@/layout/LumaEmpty"
  import {User} from "@/store/models/user"
  import axios from "@/store/vue-axios"
  import LumaUserEmail from "./luma-user-email";
  import {ApiRoutesModel} from "@/store/models/layout/api_routes";
  import LumaUserPassword from "./luma-user-password";
  import LumaAccountRights from "./luma-account-rights";
  import LumaSaveChangesButton from "../../layout/luma-save-changes-button";
  import {GetPermissions} from "@/store/models/account/account_get_permissions";

  export default {
    name: "luma-account-user",
    components: {LumaSaveChangesButton, LumaAccountRights, LumaUserPassword, LumaUserEmail, LumaEmpty},
    data:()=>({
      user_data:null,
      permissionChange:false,
      // rerenderTab:false,
      user_rights:null,
      updateTab:false
    }),
    computed:{
      userId(){
        return parseInt(this.$route.params.id,10)
      },
      userName(){
        return this.$route.params.username
      },
      account(){
        const x = User.find(this.userName)
        return x || User.fetch(this.userName)
      },
      routePramas(){
        return this.$route.params
      }
    },
    methods:{
      backToSubuser(){
        this.$router.push({name:'account-subuser'})
      },
      abortChanges(){
        this.permissionChange = false
        this.$bvModal.hide('openChanges')
      },
      async saveEmail(value){
        const params = {
          user      : this.userName,
          email  : value
        }
        const data = {
          method:'put',
          url:'/account/users/'+this.userName+'/update',
          params:params
        }
        const x = await ApiRoutesModel.simpleAxios(data)
          .then(response=>{
            this.backToSubuser()
        })
          .catch(error=>this.backToSubuser())
      },
      async savePassword(value){
        const params = {
          user      : this.account.username,
          password  : value
        }
        const data = {
          method    :'put',
          url       :'/account/users/'+this.account.username+'/update',
          params    :params
        }
        const x = await ApiRoutesModel.simpleAxios(data)
          .then(res=>this.backToSubuser())
          .catch(err=>this.backToSubuser())
      },
      changes(data){
        console.log('USERDATA',data)
        this.permissionChange = true
        this.user_data = Object.assign({},data)
      },
      savePermissions(){

        const req = axios.put('/account/users/'+this.account.username+'/permissions/update',this.user_data)
          .then(response=>{
            this.permissionChange = false
            this.backToSubuser()
          })
          .catch(error=>{
            this.permissionChange = false
            console.log('PERMISSIONS ERROR:::',error)
            this.backToSubuser()
          })
      },
      updateRights(){
        GetPermissions.fetchPermissions()
        this.updateTab = true
        setTimeout(()=>{
          this.updateTab = false
        },100)
      }

    }
    // beforeMount(){
    //   // this.permissionChange ? console.log('ROUT:::',111) : console.log('ROUT:::',222)
    // },
    // beforeUpdate(){
    //   this.permissionChange ? console.log('ROUT:::',111) : console.log('ROUT:::','AAA')
    // },
    // beforeRouteLeave(to,from,next){
    //   this.permissionChange ? this.$bvModal.show('openChanges') : next()
    // }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/details_account/luma-account-user.vue